import { h } from 'preact'
import * as firebase from 'firebase'
import FirebaseComponent from './FirebaseComponent'
import { pluck, pipe, contains, filter, head } from 'ramda'
import { NotificationManager } from 'react-notifications';

class FacebookLinker extends FirebaseComponent {
  constructor() {
    super()
    this.state = { linked: false }
    this.linkAccount = this.linkAccount.bind(this)
    this.unlinkAccount = this.unlinkAccount.bind(this)
    this.linkOrUnlink = this.linkOrUnlink.bind(this)
    this.buttonMessage = this.buttonMessage.bind(this)


    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.hasFacebookAccountLinked()
      }
    })
  }

  linkAccount() {
		this.setState({ loading: true })
		let provider = new firebase.auth.FacebookAuthProvider();

		firebase.auth().currentUser.linkWithPopup(provider).then(result => {
      const currentUser = firebase.auth().currentUser

      const getFacebookProvider = pipe(
        filter(provider => provider.providerId === 'facebook.com'),
        head
      )

      const facebookProvider = getFacebookProvider(currentUser.providerData)
      firebase.database().ref(`profiles/${currentUser.uid}/profileImage`)
        .set(facebookProvider.photoURL)

      NotificationManager.success('Your facebook account is now linked to this OAGO one', 'Account Linked');
			this.setState({ linked: true, loading: false })

		}).catch(error => {
      NotificationManager.error(error.message, 'Error');
			this.setState({ loading: false })
		});
  }

  unlinkAccount() {
    this.setState({ loading: true  })
		firebase.auth().currentUser.unlink('facebook.com').then(() => {
      NotificationManager.success('Your facebook account is no longer assosicated', 'Account Unlinked');
      this.setState({ linked: false, loading: false })
    }).catch( error => {
      NotificationManager.error(error.message, 'Error');
      this.setState({ loading: false })
		});
  }

  hasFacebookAccountLinked() {
    const providerData = firebase.auth().currentUser.providerData

    const hasFacebook = pipe(
      pluck('providerId'),
      contains('facebook.com')
    )

    this.setState({ linked: hasFacebook(providerData)})
  }

  linkOrUnlink() {
    return this.state.linked ? this.unlinkAccount : this.linkAccount
  }

  buttonMessage() {
    return this.state.linked ? "UNLINK YOUR FACEBOOK ACCOUNT" : "LINK YOUR FACEBOOK ACCOUNT"
  }

  loadingSpinner() {
    if (this.state.loading) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  render() {
    return (
      <div className="facebook-link">
        <button className="btn btn-sm btn-facebook btn-block" onClick={this.linkOrUnlink()}>
          {this.loadingSpinner()}
          <span> </span>
          <i class="fa fa-facebook-official" aria-hidden="true"></i>
          <span> </span>
          {this.buttonMessage()}
        </button>
        {this.state.message}
      </div>
    )
  }
}

export default FacebookLinker



// WEBPACK FOOTER //
// ./src/FacebookLinker.js